import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Autocomplete, TextField, useTheme } from "@mui/material";
import { useContext } from "react";
import { UserContext } from "../../hooks/UserContext";
import { useCompanyContext } from "../../hooks/CompanyContext";

interface ButtonAppBarProps {
	drawerOpen: boolean;
	setDrawerVisibility: (open: boolean) => void;
	title: string;
}

export function CustomToolbar(props: ButtonAppBarProps) {
	const theme = useTheme();
	const user = useContext(UserContext);
	const { companies, selectedCompany, setSelectedCompany } = useCompanyContext();

	const showCompanySelector = user?.isSuperUser && companies.length > 1;

	return (
		<Box style={{ zIndex: theme.zIndex.drawer + 1 }} sx={{ flexGrow: 1 }}>
			<AppBar position="static">
				<Toolbar>
					<IconButton
						size="large"
						edge="start"
						color="inherit"
						aria-label="menu"
						onClick={() => props.setDrawerVisibility(!props.drawerOpen)}
						sx={{ mr: 2 }}
					>
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
						{props.title}
					</Typography>
					{showCompanySelector && (
						<Autocomplete
							size="small"
							options={companies}
							value={selectedCompany}
							getOptionKey={(option) => option.id}
							getOptionLabel={(option) => option.name}
							isOptionEqualToValue={(option, value) => option.id === value.id}
							onChange={(_, value) => setSelectedCompany(value)}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Company"
									variant="outlined"
									size="small"
									sx={{
										"& .MuiOutlinedInput-root": {
											color: "white",
											"& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
											"&:hover fieldset": { borderColor: "white" },
											"&.Mui-focused fieldset": { borderColor: "white" },
										},
										"& .MuiInputLabel-root": { color: "rgba(255,255,255,0.7)" },
										"& .MuiInputLabel-root.Mui-focused": { color: "white" },
										"& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.7)" },
									}}
								/>
							)}
							sx={{ minWidth: 220, maxWidth: 300 }}
						/>
					)}
				</Toolbar>
			</AppBar>
		</Box>
	);
}
